import { type ReactNode, useId } from "react";

type LegalSectionProps = {
  title: ReactNode;
  children: ReactNode;
};

// Раздел документа: заголовок «1. Общие положения» и пункты.
export const LegalSection = ({ title, children }: LegalSectionProps) => {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-2">
      <h2 id={headingId} className="font-display text-[26px] leading-tight text-foreground">
        {title}
      </h2>
      {children}
    </section>
  );
};
